<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="活动名称" name="activity_name"></c-form-item>
					<c-form-item type="checkbox" label="活动状态:" name="start_state" :options="activityState"></c-form-item>
                    <c-form-item type="checkbox" label="可售范围：" name="visible_user_level" :options="userLevelOptions"></c-form-item>
                </c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_activity_tp_add" color="sys" @click="navigateTo('/activity_tp_add')">新建活动</c-button>
			</m-operate>
			
			<c-table ref="table">

				<c-table-column
					label="活动状态"
					name="start_state"
                  width="80"
                >
                   <template v-slot="{data}">
                    <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                    <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                    <span v-if="data.start_state == 2" style="color:#999">{{activityStateText[data.start_state]}}</span>
                    <span v-if="data.start_state == 3" style="color:red">{{activityStateText[data.start_state]}}</span>
                   </template>
				</c-table-column>

				<c-table-column
					label="活动名称"
					name="activity_name"
					width="200"
				></c-table-column>

                <c-table-column
                        label="可售范围"
                        width="90"
                        name="visible_user_level_name"
                >
                    <template #default="{data}">
                        <span v-if="data.visible_user_level_name && data.visible_user_level_name == '全部会员'" style="color:blue">全部会员</span>
                        <span v-else-if="data.visible_user_level_name" v-for="(item, i) in data.visible_user_level_name.split(',')" :key="i" style="color:darkslategrey;display: block;">{{item}}</span>
                        <span v-else></span>
                    </template>
                </c-table-column>
		
				<c-table-column
					label="活动时间"
					width="300"
				>
					<template v-slot="{data}">{{data.start_time}} 至 {{data.end_time}}</template>
				</c-table-column>

                <c-table-column
                        label="活动标签"
                        name="tags"
                        width="100"
                ></c-table-column>

<!--                <c-table-column
					label="用户限制"
					name="user_limit_type"
				>
                    <template v-slot="{data}">
                        <span v-if="data.user_limit_type == 0">不限制</span>
                        <span v-if="data.user_limit_type == 1">每人限买{{data.user_limit_value}} 件</span>
                    </template>
                </c-table-column>-->

                <c-table-column
                        label="创建人"
                        width="100"
                        name="create_user"
                >
                </c-table-column>
				
				<c-table-column
					label="创建时间"
					width="140"
					name="create_date"
				>
				</c-table-column>

                <c-table-column
                        label="更新人"
                        width="100"
                        name="update_user"
                >
                </c-table-column>

                <c-table-column
                        label="更新时间"
                        width="140"
                        name="update_date"
                >
                </c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="row">
						<c-table-button power="b_activity_tp_view" @click="navigateTo(`/activity_tp_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button power="b_activity_tp_state" v-if="row.data.state == 1 && row.data.start_state != 2" @click="changeActivityState(row,0)">禁用</c-table-button>
                        <c-table-button power="b_activity_tp_state" v-if="row.data.state == 0 && row.data.start_state != 2" @click="changeActivityState(row,1)">启用</c-table-button>
                        <c-table-button power="b_activity_tp_edit" v-if="row.data.state == 0 && row.data.start_state != 2" @click="navigateTo(`/activity_tp_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button power="b_activity_tp_remove" v-if="row.data.state == 0 || row.data.start_state == 2" @click="deleteActivity(row)">删除</c-table-button>
                        <c-table-button power="b_activity_tp_view" @click="saleAnalysis(row)">活动销售情况</c-table-button>
					</template>
				</c-table-column>
			</c-table>

            <c-dialog ref="saleAnalysisDialog"
                      :title="saleAnalysisDialogTitle"
                      width="1200"
                      height="auto"
                      :button="true"
                      :close-button="true"
            >
                <m-search ref="searchSaleAnalysis" @search="searchSaleAnalysisHandle">
                    <c-form>
                        <c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
                    </c-form>
                </m-search>

                <c-table ref="salesAnalysisTable" style="height:600px">
                    <c-table-column label="商品信息" name="order_state" width="400">
                        <template v-slot="{data}">
                            <div style="display: flex;align-items: center;">
                                <c-image width="50px" height="50px" :src="data.product_img_url"></c-image>
                                <div style="margin-left: 10px;width: 80%">
                                    <p style="font-size: 12px;color: #666;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{data.product_name}}</p>
                                    <p style="margin-top: 3px;font-size: 12px;">{{data.product_sku_spec}}</p>
                                </div>
                            </div>
                        </template>
                    </c-table-column>
                    <c-table-column label="商品数量" name="product_count" width="100"></c-table-column>
                    <c-table-column label="商品金额" name="product_money" width="120">
                        <template v-slot="{data}">￥{{ parseFloat(data.product_money).toFixed(2) }}</template>
                    </c-table-column>
                    <c-table-column label="下单时间" name="create_date" width="140"></c-table-column>
                    <c-table-column label="订单号" name="order_number" width="120">
                        <template v-slot="{data}">
                            <p>{{data.order_number}}</p>
                            <p style="margin-top: 2px;" ><a @click="navigateTo(`/order_detail/${data.order_number}`)" power="b_order_detail" style="color: blue">订单详情</a></p></template>
                    </c-table-column>
                </c-table>
            </c-dialog>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_activity_tp',
		
		data() {
			return {
				activityState: [{
						name: '未开始',
						value: 0
					}, {
						name: '进行中',
						value: 1
					}, {
						name: '已结束',
						value: 2
					}, {
						name: '暂停中',
						value: 3
					}
				],
                selectId: '',
                saleAnalysisDialogTitle:'',
                userLevelOptions: []
            }
		},
		
		computed: {
			activityStateText() {
				var state = {};
				this.activityState.forEach(item => {
					state[item.value] = item.name;
				});
				return state;
			}
		},
		
		mounted() {
            this.initUserLevelOptions();
            this.$refs.search.search();
			this.$bus.$on('activityTpList.update', () => {
                this.$refs.search.search();
			});
		},

        beforeDestroy() {
            // 组件销毁前移除事件监听器
            this.$bus.$off('activityTpList.update');
        },
		
		methods: {
            //加载会员等级列表
            initUserLevelOptions(){
                this.request({
                    url: '/user_level/options',
                    data: {},
                    success: data => {
                        this.userLevelOptions = Array.from(data, item => {
                            return {
                                name: item.name,
                                value: item.value
                            }
                        });
                    }
                });
            },
			searchHandle(data) {
				this.$refs.table.load({
					url: '/activityTp/list',
					data
				});
			},
            // 修改状态
			changeActivityState(item,state) {
				this.$confirm({
					text: '确定要'+(state==1?"启用":"禁用")+'多件优惠购活动【'+item.data.activity_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/activityTp/updateState',
							data: {
								id: item.data.id,
                                state:state
							},
							loading: true,
							success: () => {
								this.$message({
									text: state==1?'启用成功':'禁用成功'
								});
								this.$refs.table.update();
							},
                            fail: (code, data, msg) => {
                                this.$confirm({
                                    text: msg,  // 提示内容,
                                    buttonName: '知道了',  // 确定按钮文字
                                    cancelButton: false  // 是否显示取消按钮
                                });
                                return false;
                            }
						});
					}
				});
			},
			// 删除
			deleteActivity(item) {
				this.$confirm({
					text: '确定要删除此活动【'+item.data.activity_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/activityTp/delete',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
            saleAnalysis(row) {
                this.selectId = row.data.id;
                this.saleAnalysisDialogTitle = '活动【'+row.data.activity_name+'】销售情况';
                this.$refs.searchSaleAnalysis.search();
                this.$refs.saleAnalysisDialog.open();
            },
            searchSaleAnalysisHandle(data){
                this.$refs.salesAnalysisTable.load({
                    url: '/statistic/activity/productSaleAnalysis',
                    data: {
                        activity_id: this.selectId,
                        ...data
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>

</style>